import * as React from 'react';
import xssFilters from 'xss-filters';
import { StringMode } from '@comall-backend-builder/types';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../../services';

export class StringReportsUrlMode extends StringMode {
    /**
     * 报表下载
     */
    public getAvailableDisplayComponent(value: any, displayInfo: any) {
        const { row, textProperty, conditionProperty, isSignature } = displayInfo;
        value = xssFilters.uriInDoubleQuotedAttr(value);
        // 此函数只供报表导出管理中发货单类型的报表下载调用，因为此报表对接了鸿鹄中台报表需要签名
        const hanldePrivateDownLoad = async (filePath: string) => {
            services.api
                .get({ download_url: filePath }, { apiPath: `/shippingOrder/exportDownload` })
                .then((res: any) => {
                    if (Object.keys(res).length != 0) {
                        const { data } = res;
                        const fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
                        const downloadLink = document.createElement('a');
                        downloadLink.href = data;
                        downloadLink.download = fileName;
                        downloadLink.target = '_blank';
                        downloadLink.click();
                    }
                })
                .catch((e: any) => {
                    errorHandle(e);
                });
        };
        return (
            <div>
                {!conditionProperty || row[conditionProperty] ? (
                    // 因为此下载文件逻辑导入管理和到处管理模块都在使用，增加此判断只意味着报表导出的发货单报表下载
                    row[isSignature] === 'SHIPPING_ORDER' ? (
                        <a onClick={() => hanldePrivateDownLoad(value)}>{row[textProperty]}</a>
                    ) : (
                        <a href={value} target="_blank">
                            {row[textProperty]}
                        </a>
                    )
                ) : null}
            </div>
        );
    }
}
